"use strict";

var _regeneratorRuntime = require("/codebuild/output/src663409388/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rootSaga;
exports.sagaMiddleware = void 0;

var _reduxSaga = _interopRequireDefault(require("redux-saga"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(rootSaga); // notice how we now only export the rootSaga
// single entry point to start all Sagas at once


function rootSaga() {
  return _regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

var sagaMiddleware = (0, _reduxSaga.default)();
exports.sagaMiddleware = sagaMiddleware;